import { TotalizersGrid } from "@/modules/common/components";
import { AdminUsersTotalizersResponse } from "@/service/response/admin-users";
import { CheckCircle2, ShieldCheckIcon, UserIcon, XCircle } from "lucide-react";

interface UsersTotalizersParams {
  data?: AdminUsersTotalizersResponse;
  isLoading?: boolean;
  className?: string;
}

const UsersTotalizers = ({ data, isLoading = false, className }: UsersTotalizersParams) => (
  <TotalizersGrid
    className={className}
    isLoading={isLoading}
    items={[
      {
        key: "global-administrators",
        title: "Administradores Globais",
        value: data?.totalGlobalAdministrators,
        icon: <ShieldCheckIcon className="w-5 h-5 text-blue-900 font-bold" />,
        iconWrapperClassName: "bg-sky-800/20",
      },
      {
        key: "analysts",
        title: "Analistas",
        value: data?.totalAnalysts,
        icon: <UserIcon className="w-5 h-5 text-blue-900 font-bold" />,
        iconWrapperClassName: "bg-sky-800/20",
      },
      {
        key: "active",
        title: "Ativos",
        value: data?.totalActive,
        icon: <CheckCircle2 className="w-5 h-5 text-green-500 font-bold" />,
        iconWrapperClassName: "bg-emerald-100",
      },
      {
        key: "inactive",
        title: "Inativos",
        value: data?.totalInactive,
        icon: <XCircle className="w-5 h-5 text-red-500 font-bold" />,
        iconWrapperClassName: "bg-red-100",
      },
    ]}
  />
);

export default UsersTotalizers;
